import { createAction } from '@reduxjs/toolkit'

import { SelectAll } from 'types/SelectAll'

// SelectAll object sets property for grid or page level selection of all participants.
export const setSelectAll = createAction(
  'participant/setSelectAll',
  function prepare(selectAll: SelectAll) {
    return {
      payload: {
        selectAll,
      },
    }
  },
)
